// removed by extract-text-webpack-plugin
module.exports = {"bottomContent":"Gcf4be3"};